import { useParams } from 'react-router-dom';
import AdminPage from '../../components/admin/AdminPage';
import { Col, Row } from 'reactstrap';
import AdminUploadFile from '../../components/admin/AdminUploadFile';
import { FilePreviewTypes } from '../../constants/formConstants';
import InvestorProjectModelSelectUnitToCsvModal from './components/InvestorProjectModelSelectUnitToCsvModal';
import AdminCard from '../../components/admin/AdminCard';
import useProjectModelUnit from './hooks/useProjectModelUnit';
import { useCallback, useState } from 'react';
import { AdminAlerts } from '../../models/alertModel';
import LoadingCard from '../../components/LoadingCard';

const ModelUnitBulkEdit = () => {
  const { id: modelId = '' } = useParams();

  const pageName = 'Editar unidades a través de CSV';
  const parentPageName = 'Modelo';

  const [alert, setAlerts] = useState<AdminAlerts | undefined>(undefined);

  const { apiErrors, apiSuccess, doEditUnitsPerModelInBulk, isLoading } =
    useProjectModelUnit();

  const uploadCSVForProcessing = useCallback(async (files: Array<any>) => {
    if (!files.length) {
      setAlerts({
        success: false,
        warning: true,
        title: 'Error',
        text: 'Error, debes de adjuntar un archivo para subir',
        onConfirm: () => setAlerts(undefined),
      });
      return;
    }
    const formData = new FormData();
    formData.append('model_unit_file', files[0]);

    const result = await doEditUnitsPerModelInBulk(modelId, formData);

    if (result) {
      //actualizado
      setAlerts({
        success: true,
        warning: false,
        title: 'Exito',
        text: `${apiSuccess ?? 'Ok'}`,
        onConfirm: () => setAlerts(undefined),
      });
    } else {
      setAlerts({
        success: false,
        warning: true,
        title: 'Error',
        text: `${apiErrors ?? 'Error'}`,
        onConfirm: () => setAlerts(undefined),
      });
    }
  }, []);

  if (isLoading) {
    return <LoadingCard name={pageName} parent_name={parentPageName} />;
  }

  return (
    <AdminPage
      name={pageName}
      parentName={parentPageName}
      globalAlertOptions={alert}
    >
      <Row>
        <Col>
          <AdminCard
            children={
              <InvestorProjectModelSelectUnitToCsvModal model_id={modelId} />
            }
            title="Tienes que seleccionar las unidades a editar"
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AdminUploadFile
            handleUpload={uploadCSVForProcessing}
            description={'Editar unidades via CSV'}
            dropZoneText={'Subir CSV'}
            maxFiles={1}
            filesPreviewType={FilePreviewTypes.COUNT}
          />
        </Col>
      </Row>
    </AdminPage>
  );
};

export default ModelUnitBulkEdit;
